import React from "react";
import { classNames } from "../../../utils/helpers";
import { Badge } from "react-bootstrap";
import PropTypes from "prop-types";
import { FormatDateWTime } from "../../../utils/FormatData";
const CardLog = (props) => {
  const {
    b_isrcs,
    i_messages,
    vc_carrier,
    vc_msisdn,
    vc_provider,
    vc_resultcode,
    vc_source,
    j_details,
    time_id,
    time_response,
    vc_shortcode,
  } = props.data;
  const getStatus = (sms) => {
    if (sms.b_ok) return "OK";
    if (sms.b_waiting) return "WAITING";
    if (sms.b_errorcarrier) return "ERROR_CARRIER";
    if (sms.b_invalidnumber) return "INVALID";
    return "UNKNOWN";
  };

  const statusMessage = ({ sms }) => {
    const status = getStatus(sms);

    switch (status) {
      case "OK":
        return <Badge bg="success">Entregado</Badge>;

      case "WAITING":
        return <Badge bg="warning">En Proceso</Badge>;

      case "ERROR_CARRIER":
        return <Badge bg="danger">Error Operadora</Badge>;

      case "INVALID":
        return <Badge bg="danger">No Valido (Numero Invalido)</Badge>;

      case "UNKNOWN":
        return <Badge bg="danger">No Valido</Badge>;

      default:
        return <Badge bg="danger">No Valido</Badge>;
    }
  };

  const result_code_message = (message) => {
    if (!message) return "---";

    if (message === "FALLBACK SMS") {
      return "Ejecutando Fallback SMS";
    }

    return message;
  };

  const typeMsg = ({ sms }) => {
    if (sms.b_isrcs) return "RCS";
    if (sms.b_iswhatsapp) return "WhatsApp";
    if (sms.b_isemail) return "Email";
    return "SMS";
  };
  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden">
      {/* Header compacto */}
      <div className="px-4 py-2 border-b border-gray-50 bg-gray-200 rounded-tl-lg rounded-tr-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div
              className={classNames(
                "px-2 py-1 rounded-full text-[12px] font-medium tracking-wide",
                {
                  "bg-purple-50 text-purple-700 border border-purple-100":
                    !b_isrcs,
                  "bg-blue-50 text-blue-700 border border-blue-100": b_isrcs,
                },
              )}
            >
              {typeMsg({ sms: props.data })}
            </div>
            <span className="text-[12px] text-gray-500">
              {statusMessage({ sms: props.data })}
            </span>
          </div>

          {/* Indicador compacto */}
          {i_messages > 1 ? (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[12px] font-medium bg-amber-50 text-amber-700 border border-amber-100">
              <span className="w-1 h-1 bg-amber-500 rounded-full mr-1"></span>
              Extendido
            </span>
          ) : (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[12px] font-medium bg-gray-50 text-gray-600 border border-gray-100">
              Normal
            </span>
          )}
        </div>
      </div>

      {/* Cuerpo compacto */}
      <div className="p-3 space-y-2">
        {/* Teléfono y fuente */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-full bg-blue-50 flex items-center justify-center">
              <span className="material-symbols-outlined text-blue-600 text-sm">
                phone
              </span>
            </div>
            <span className="font-semibold text-sm">{vc_msisdn}</span>
          </div>
          <div className="flex items-center gap-1 text-xs text-gray-500">
            <span className="material-symbols-outlined text-xs">api</span>
            <span>{vc_source}</span>
          </div>
        </div>

        {/* Mensaje compacto */}
        <div className="bg-gray-100 rounded-lg p-2 ">
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined text-gray-400 text-sm">
              sms
            </span>
            <span className="text-gray-700 text-xs line-clamp-2 font-mono">
              {j_details.Message}
            </span>
          </div>
        </div>

        {/* Metadatos en fila compacta */}
        <div className="flex items-center justify-between text-[12px]">
          <div>
            <span className="text-gray-400 font-semibold">Envío:</span>
            <span className="text-gray-700 ml-1 font-semibold">
              {FormatDateWTime(time_id)}
            </span>
          </div>
          <div>
            <span className="text-gray-400 font-semibold">Respuesta:</span>
            <span className="text-gray-700 ml-1 font-semibold">
              {FormatDateWTime(time_response)}
            </span>
          </div>
          <div>
            <span className="text-gray-400 font-semibold">Máscara:</span>
            <span className="text-gray-700 ml-1 font-semibold">
              {vc_shortcode || "---"}
            </span>
          </div>
        </div>
        {/* <div className="flex items-center justify-between text-[10px]">
                            <div>
                              <span className="text-gray-400 font-semibold">
                                Carrier:
                              </span>
                              <span className="text-gray-700 ml-1 font-semibold">
                                {vc_carrier }
                              </span>
                            </div>
                            <div>
                              <span className="text-gray-400 font-semibold">
                                Proveedor:
                              </span>
                              <span className="text-gray-700 ml-1 font-semibold">
                                {vc_provider || "Sin Operadora"}
                              </span>
                            </div>
                         
                          </div> */}

        {/* Footer compacto */}
        <div className="flex justify-between items-center gap-1 pt-1 border-t border-gray-50">
          <div className="flex items-center justify-start gap-1">
            <span
              className={classNames(
                "px-2 py-0.5 text-[10px] font-medium rounded-full",
                {
                  "bg-blue-200 text-blue-700 ": vc_carrier == "Telcel",
                  "bg-green-200 text-green-700 ": vc_carrier == "Movistar",
                  "bg-amber-200 text-amber-700 ":
                    vc_carrier != "Telcel" && vc_carrier != "Movistar",
                },
              )}
            >
              {vc_carrier || vc_provider || "Sin Operadora"}
            </span>
            <span className="px-2 py-0.5 bg-gray-200 text-gray-600 text-[10px] font-medium rounded-full ">
              {vc_provider || "Sin Operadora"}
            </span>
          </div>
          <span className="px-2 py-0.5 bg-gray-700 text-white text-[12px] font-medium rounded-full border border-gray-100">
            {result_code_message(vc_resultcode)}
          </span>
        </div>
      </div>
    </div>
  );
};

CardLog.propTypes = {
  data: PropTypes.object,
};

export default CardLog;
